import { render, staticRenderFns } from "./AddressSelectorModal.vue?vue&type=template&id=03d72cda&scoped=true&"
import script from "./AddressSelectorModal.vue?vue&type=script&lang=js&"
export * from "./AddressSelectorModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressSelectorModal.vue?vue&type=style&index=0&id=03d72cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d72cda",
  null
  
)

export default component.exports